import { Button, Card, CardContent, Grid } from '@mui/material'
import React from 'react'
import { useLocation, useParams } from 'react-router-dom';
import { Plus } from 'react-feather'
import { AllowedAccess } from 'react-permission-role'
import { VehicleCatalogTable } from './VehicleCatalogTable/VehicleCatalogTable'
import { useFechInitVehicleCatalog } from './hooks';
import { VehicleForm } from './VehicleForm/VehicleForm';
import { VehicleImages } from './VehicleImages/VehicleImages';
import { VehicleExpenses } from './VehicleExpenses/VehicleExpenses';
import { VehicleStatus } from './VehicleStatus/VehicleStatus';

export const VehicleCatalog = () => {

  const location = useLocation();
  const paramsURL = useParams();
  const useFetchInit = useFechInitVehicleCatalog({location, paramsURL})

  const {
    globalStates,
    Actions
  } = useFetchInit
  
  const { showSection } = globalStates
  const { handleClickShowForm } = Actions


  return (
    <AllowedAccess permissions={['49_ADMIN', '146_CATALOGO_VEHICULOS']} renderAuthFailed={<p>Error</p>}>
      <div className='content'>
        {(showSection==='HOME')&&(
          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card style={{zIndex:'1'}}>
                <CardContent>
                  <div className='h4 mt-1 mb-1'> Catalogo de Vehiculos</div>
                  <div className="border-bottom border-dark"></div>

                  <Button
                    startIcon={<Plus/>}
                    size='medium'
                    type='button'
                    variant='contained' 
                    color='primary' 
                    sx={{marginTop: 4}}
                    onClick={() => handleClickShowForm()}
                  >
                      Nuevo Vehiculo
                  </Button>

                  <div className="pt-4"></div>
                  <VehicleCatalogTable 
                    useFetchInit={useFetchInit}
                  />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        )}
        {(showSection==='FORM') && (
            <div className='panel-body' id='formularioregistros'>
                <VehicleForm 
                    useFetchInit={useFetchInit}
                />
            </div>
        )}
        {(showSection==='IMAGES') && (
            <div className='panel-body' id='formularioregistros'>
                <VehicleImages 
                    useFetchInit={useFetchInit}
                />
            </div>
        )}
        {(showSection==='EXPENSES') && (
            <div className='panel-body' id='formularioregistros'>
                <VehicleExpenses 
                    useFetchInit={useFetchInit}
                />
            </div>
        )}
        {(showSection==='STATUS') && (
            <div className='panel-body' id='formularioregistros'>
                <VehicleStatus 
                    useFetchInit={useFetchInit}
                />
            </div>
        )}
      </div>
    </AllowedAccess>
  )
}
